export function normalizeWsSuperadminCopyValue(
  value: string | number | null | undefined
): string {
  if (value == null || value === '') {
    return '';
  }
  return String(value).trim();
}

export function formatWsAdminIdDisplay(
  value: string | number | null | undefined,
  truncate = true
): string {
  const normalized = normalizeWsSuperadminCopyValue(value);
  if (!truncate || !normalized.includes('-')) {
    return normalized;
  }
  return normalized.split('-')[0];
}
